import { useState, type CSSProperties } from 'react';
import { playUiClickB } from '../../../../../assets/preloadSounds';
import { containFitScale } from '../../../../../../infrastructure/runtime';
import { useAppFit } from '../../../../../hooks/useAppFit';
import './NavBar.css';
import { NavBarButton } from '../../../atomic/buttons/nav_bar_button/NavBarButton';
import mapIcon from './map_icon.png';
import deliveriesIcon from './deliveries_icon.png';
import rewardsIcon from './rewards_icon.png';

export type NavBarTab = 'map' | 'deliveries' | 'rewards';

type NavBarProps = {
  activeTab?: NavBarTab;
  onTabChange?: (tab: NavBarTab) => void;
  className?: string;
  style?: CSSProperties;
};

/**
 * Bottom navigation — three equal-width tabs (flex), not Figma absolute slots.
 */
export function NavBar({
  activeTab: controlledTab,
  onTabChange,
  className,
  style,
}: NavBarProps) {
  const [uncontrolledTab, setUncontrolledTab] = useState<NavBarTab>('map');
  const activeTab = controlledTab ?? uncontrolledTab;
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  const select = (tab: NavBarTab) => {
    playUiClickB();
    if (controlledTab === undefined) {
      setUncontrolledTab(tab);
    }
    onTabChange?.(tab);
  };

  return (
    <nav
      className={['nav-bar', className].filter(Boolean).join(' ')}
      style={
        {
          '--fit-contain-inv-x': String(contain.invX),
          '--fit-contain-inv-y': String(contain.invY),
          '--fit-contain-uniform': String(contain.uniform),
          ...style,
        } as CSSProperties
      }
      aria-label="Навигация"
    >
      <NavBarButton
        className="nav-bar__button--map"
        active={activeTab === 'map'}
        onClick={() => select('map')}
      >
        <img
          className="nav-bar__icon nav-bar__icon--map"
          src={mapIcon}
          alt=""
          draggable={false}
          aria-hidden
        />
        <span className="nav-bar__label nav-bar__label--map">Карта</span>
      </NavBarButton>
      <NavBarButton
        className="nav-bar__button--deliveries"
        active={activeTab === 'deliveries'}
        onClick={() => select('deliveries')}
      >
        <img
          className="nav-bar__icon nav-bar__icon--deliveries"
          src={deliveriesIcon}
          alt=""
          draggable={false}
          aria-hidden
        />
        <span className="nav-bar__label nav-bar__label--deliveries">
          Мои доставки
        </span>
      </NavBarButton>
      <NavBarButton
        className="nav-bar__button--rewards"
        active={activeTab === 'rewards'}
        onClick={() => select('rewards')}
      >
        <img
          className="nav-bar__icon nav-bar__icon--rewards"
          src={rewardsIcon}
          alt=""
          draggable={false}
          aria-hidden
        />
        <span className="nav-bar__label nav-bar__label--rewards">Награды</span>
      </NavBarButton>
    </nav>
  );
}
